import { render, staticRenderFns } from "./smartguardianfield.vue?vue&type=template&id=50ae71e2&scoped=true"
import script from "./smartguardianfield.vue?vue&type=script&lang=js"
export * from "./smartguardianfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae71e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
